<div *ngIf="!hideProgress">
  <ng-container *ngIf="isIndeterminate; else regularProgressBar">
    <div [style.height]="height" [style.line-height]="height" class="progress">
      <div class="progress-bar-indeterminate inc" [style.background-color]="color"></div>
      <div class="progress-bar-indeterminate desc" [style.background-color]="color"></div>
      <div class="progress-bar-label" [style.color]="labelColor">
        <ng-content></ng-content>
      </div>
    </div>
  </ng-container>

  <ng-template #regularProgressBar>
    <ng-container *ngIf="!topLabel; else topLabelBar">
      <ng-container *ngIf="!bottomLabel; else bottomLabelBar">
        <div [style.height]="height" [style.line-height]="height" class="progress">
          <ng-container *ngTemplateOutlet="progressbar; context: { $implicit: { color: color, maxValue: maxValue, value: value } }"></ng-container>
          <div class="progress-bar-label">
            <span *ngIf="showValue" [style.color]="labelColor">
              <span *ngIf="customLabel; else defaultLabel" [innerHTML]="customLabel | tiSafeHtml"></span>
                <ng-template #defaultLabel>
                  {{ getPercentage() }}
                  <ng-container *ngIf="showPercentSign">%</ng-container>
                  {{ hint }}
                </ng-template>
            </span>
            <ng-content></ng-content>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <ng-template #topLabelBar>
      <div class="progress-container">
          <span *ngIf="showValue" [style.color]="labelColor">
            <span *ngIf="customLabel; else defaultLabel" [innerHTML]="customLabel | tiSafeHtml"></span>
              <ng-template #defaultLabel>
                {{ getPercentage() }}
                <ng-container *ngIf="showPercentSign">%</ng-container>
                {{ hint }}
              </ng-template>
          </span>
        <div [style.height]="height" [style.line-height]="height" class="progress">
          <ng-container *ngTemplateOutlet="progressbar; context: { $implicit: { color: color, maxValue: maxValue, value: value } }"></ng-container>
        </div>
      </div>
    </ng-template>

    <ng-template #bottomLabelBar>
      <div class="progress-container">
        <div [style.height]="height" [style.line-height]="height" class="progress">
          <ng-container *ngTemplateOutlet="progressbar; context: { $implicit: { color: color, maxValue: maxValue, value: value } }"></ng-container>
        </div>
        <span *ngIf="showValue" [style.color]="labelColor">
          <span *ngIf="customLabel; else defaultLabel" [innerHTML]="customLabel | tiSafeHtml"></span>
            <ng-template #defaultLabel>
              <div class="default-label">
                <div class="default-label_percentage">
                  {{ getPercentage() }}
                  <ng-container *ngIf="showPercentSign">%</ng-container>
                </div>
                <div class="default-label_hint">{{hint}}</div>
              </div>
            </ng-template>
        </span>
      </div>
    </ng-template>
  </ng-template>
</div>

<ng-template #progressbar let-options>
  <div
    class="progress-bar"
    role="progressbar"
    [style.background-color]="options.color"
    [style.transform]="'translateX('+ (getPercentage() - 100) + '%)'"
    aria-valuemin="0"
    [attr.aria-valuemax]="options.maxValue"
    [attr.aria-valuenow]="options.value"
  ></div>
</ng-template>
